import React from "react";

export const AppContext = React.createContext({
  email: "",
  key: false,
  currentFlights: [],
  showAirborne: false,
  setShowAirborne: () => {},
});
